<!-- 大屏切换页 -->
<template>
    <div class="fullScreen_swiper flex_center">
        <swiper class="swiper_wrap" :options="swiperOption" ref="fullScreenSwiper">
            <!-- slides -->
            <swiper-slide v-for="(item,index) in swiperData" :key="index">
                <div class="swiper_item">
                    <div class="item_img" :class="['bg'+(index+1)]" @click="changeRouter(item)"></div>
                    <template v-if="item.btn.length">
                        <button
                            class="item_btn"
                            :class="{
                                'showBtn':activeTab==index,
                                'active':activeTab==activeTabNum&&activeBtnNum==idx,
                            }"
                            v-for="(btn,idx) in item.btn"
                            :key="idx"
                            @click="changeRouter(btn)">
                            {{btn.label}}
                        </button>
                    </template>
                </div>
            </swiper-slide>
        </swiper>
        <i class="el-icon-arrow-left arrow_icon i_left"></i>
        <i class="el-icon-arrow-right arrow_icon i_right"></i>
    </div>
</template>

<script>
import { swiper, swiperSlide} from 'vue-awesome-swiper'
import permission from "@/mixins/permission.js";
import ajaxService from '@/server/api.js'
export default {
     mixins:[permission],
    data() {
        let _this = this ;
        return {
            activeTab:0,
            swiperOption:{
                effect : 'coverflow',
                loop:false,
                slidesPerView: 4,//设置slider容器能够同时显示的slides数量
                // slideToClickedSlide: true,//点击slide会过渡到这个slide
                centeredSlides: true,//active的tab居中
                navigation: {
                    nextEl: '.i_right',
                    prevEl: '.i_left',
                    disabledClass: 'my-button-disabled',
                },
                coverflowEffect: {
                    rotate: 0,//侧转角度（正值凹陷）
                    depth: 160,//值越大为远景（可负值）
                    modifier: 3,
                    stretch:-12,//每个slide之间的拉伸值，越大slide靠得越紧。 默认0
                    slideShadows:false,
                },
                on:{
                    slideChange(){
                        _this.activeTab=this.realIndex
                        // _this.activeBtnNum=null
                        // console.log('改变了',this.realIndex,_this.activeTab);
                    },
                    click(e){
                        console.log('click',e,_this.activeTab)
                    }
                },
            },
             // 子账户权限 1:房企拿地监控 2:房企项目 3:全装修 4:招标采购 5:研究报告 6:我的业绩
            swiperData:[
                {
                    src:'/fullscreen/land',
                    img:'../assets/imgs/swiper/swiper01.png',
                    role:1,
                    btn:[
                        {src:'/fullscreen/land',label:'房企拿地监控系统',role:1},
                        {src:'/page/land',label:'房企拿地监控系统列表',role:1},
                    ]
                },
                {
                    src:'/fullscreen/project',
                    img:'../assets/imgs/swiper/swiper02.png',
                    role:2,
                    btn:[
                        {src:'/fullscreen/project',label:'房企项目开工监控系统',role:2},
                        {src:'/page/project',label:'房企项目开工监控系统列表',role:2},
                    ]
                },
                {
                    src:'/fullscreen/market',
                    img:'../assets/imgs/swiper/swiper03.png',
                    role:3,
                    btn:[
                        {src:'/fullscreen/market',label:'全装修市场监控系统',role:3},
                        {src:'/page/market',label:'全装修市场监控系统列表',role:3},
                    ]
                },
                {
                    src:'/fullscreen/market',
                    img:'../assets/imgs/swiper/swiper03.png',
                    role:4,
                    btn:[
                        {src:'/fullscreen/market',label:'采购大数据服务系统',role:4},
                        {src:'/page/tender',label:'采购大数据服务列表',role:4},
                    ]
                },
                {
                    src:'/fullscreen/report',
                    img:'../assets/imgs/swiper/swiper04.png',
                    role:6,
                    btn:[
                        {src:'/fullscreen/report',label:'我的业绩报告',role:6},
                    ]
                }
            ],
            indexUrl: null,
            listUrl:null,
            activeTabNum:null,
            activeBtnNum:null
        }
    },
    computed: {
        myswiper() {
            return this.$refs.fullScreenSwiper.swiper
        },
    },
    watch: {
        activeTab(){
            this.setOpacity()
        }
    },
    mounted() {
         this.getJumpUrlList()
        //  this.initShow()
        this.setOpacity()
        
    },
    methods: {
        initShow(){
            let path=this.$route.path
            // console.log(path)
            let pathArr=path.split('/')
            if(path=='/'){//首页——目前对应 房企拿地大屏
                this.activeTabNum=0
                this.myswiper.slideToLoop(0, 0, false)
                this.activeBtnNum=0;
                this.setJumpZBurl(this.swiperData[3])
                console.log(this.activeBtnNum,'2222')
            }else if(path=='/page/detail'){//详情页
                this.activeTabNum=this.$route.query.module-1
                this.myswiper.slideToLoop(this.activeTabNum, 0, false)
                this.activeBtnNum=1;
                this.setJumpZBurl(this.swiperData[3])
            }else{
                this.swiperData.forEach((item,index)=>{
                    //判断role=4时，跳转到外部大屏
                    if(item.role === 4) {
                        this.setJumpZBurl(item)
                    } else {
                        let baseArr=item.src.split('/')
                        if(baseArr[baseArr.length-1]==pathArr[pathArr.length-1]){
                            this.activeTabNum=index
                            this.myswiper.slideToLoop(index, 0, false)
                        }
                        switch(pathArr[pathArr.length-2]){
                            case 'fullscreen':
                                this.activeBtnNum=0;
                                break;
                            case 'page':
                                this.activeBtnNum=1;
                                break;
                        }
                    }
                  
                })
            }
        },
        setJumpZBurl(item){
            //设置中标采购url
            item.src = this.indexUrl
            item.btn[0].src = this.indexUrl
            item.btn[1].src = this.listUrl
        },
        changeRouter(btn){
            // console.log(btn,this.sUserRole)
            if(this.sUserRole.length>0 &&  !this.sUserRole.includes(btn.role)){
                    this.showTip();
                    return
            }
            if(btn.role === 4) {
                //判断role=4时，跳转到外部大屏
                window.open(btn.src, '_blank')
            } else {
                this.$router.push({
                    path: btn.src,
                })
            }
            
            this.$emit('showFullSwiper',false);
        },
        setOpacity(){
            let n = this.myswiper.slides.length
            if(n==0) return;
            let zindexArr = []
            for(var i=0; i<n; i++){
                zindexArr.push(this.myswiper.slides[i].style.zIndex)
            }
            let minIndex = 0
            let maxIndex = n-1
            zindexArr.forEach((item,index)=>{
                if(Number(item)<Number(zindexArr[minIndex])){
                    minIndex=index
                }
                if(Number(item)>Number(zindexArr[maxIndex])){
                    maxIndex=index
                }
            })
            for(var i=0; i<n; i++){
                if(i==minIndex){
                    this.myswiper.slides[i].style.opacity=0.5
                }else if(i==maxIndex){
                    this.myswiper.slides[i].style.opacity=1
                }else{
                    this.myswiper.slides[i].style.opacity=0.8
                }
            }
        },
        getJumpUrlList(){
            ajaxService.getJumpUrl().then(res=>{
                // console.log('跳转url',res)
                if(!res.ErrorCode){
                    let {index, list} = res.Data
                    this.indexUrl = index
                    this.listUrl = list 
                    this.initShow()
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.fullScreen_swiper{
    position: fixed;
    left: 0;
    top:0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.8);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .swiper_wrap{
        // width: 88vw;
        width: 90vw;
        height: 68vh;
        // margin: 0 auto;
        
    }

    .swiper_item{
        width: 7.69rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        position: relative;
        left: 50%;
        transform: translateX(-50%);

        
        .item_img{
            width:100%;
            height: 4.32rem;
            box-shadow: 0 .05rem .4rem 0 #000;
            background: #333;
            background-size: cover;
            background-position: 0 0;
            &.bg1{ background-image: url('../assets/imgs/swiper/swiper01.png');}
            &.bg2{ background-image: url('../assets/imgs/swiper/swiper02.png');}
            &.bg3{ background-image: url('../assets/imgs/swiper/swiper03.png');}
            &.bg4{ background-image: url('../assets/imgs/swiper/swiper04.png');}
            &.bg5{ background-image: url('../assets/imgs/swiper/swiper05.png');}
        }
        .item_btn{
            width: 3.3rem;
            height: .8rem;
            background-color: inherit;
            background-image: url('../assets/imgs/fullScreen_btn_m.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            color: white;
            font-size: .24rem;
            margin-top: .2rem;
            display: none;
            &.active,&:hover{
                background-image: url('../assets/imgs/fullScreen_btn_c.png');
            }
        }
    }
    .swiper-slide-active{
        .showBtn{
            display: block;
        }
    }

    .arrow_icon{
        position: absolute;
        top:50%;
        transform: translateY(-50%);
        z-index: 1000;
        color: white;
        font-size: .6rem;
        cursor: pointer;
        outline: none;
        &.i_left{
            left: 3rem;
        }
        &.i_right{
            right: 3rem;
        }
    }
    
    .my-button-disabled{
        color: #666;
    }
}
</style>
<style lang="scss">

.fullScreen_swiper{

    .swiper-wrapper{
        // z-index: 0;
        // pointer-events: none;
    }
    .swiper-slide{
        // width: 7.69rem;
    }
}
</style>